import graphql__ce7f63320eed2542fa3a from "./__generated__/ContributionRouteQuery.graphql.js";import { graphql } from "react-relay";
import { useParams } from "react-router";
import AppQueryRenderer from "../AppQueryRenderer";

import ContributionModal from "../Contributions/ContributionModal";
import ModalLoader from "../Modals/ModalLoader";
import ModalErrorBoundary from "../ErrorBoundaries/ModalErrorBoundary";

const ContributionRoute = props => {
  const { contributionSlug } = useParams();

  return (
    <AppQueryRenderer
      key={contributionSlug}
      query={ContributionRouteQuery}
      variables={{ contributionSlug }}
      component={ContributionModal}
      additionalProps={props}
      loader={<ModalLoader />}
      ErrorBoundary={ModalErrorBoundary}
    />
  );
};

const ContributionRouteQuery = graphql__ce7f63320eed2542fa3a;

export default ContributionRoute;
